export default {
  stats: {
    title: "Estadísticas",
    tabs: {
      team: "Estadísticas de equipo",
      player: "Estadísticas de jugador",
    },
    empty: {
      unavailable: "Las estadísticas no están disponibles en este momento.",
    },
    filters: {
      titles: {
        qualifier: "Modo",
        type: "Tipo",
        position: "Posición",
      },
      plurals: {
        qualifier: "Modos",
        type: "Tipos",
        position: "Posiciones",
      },
      options: {
        type: {
          offensive: "Ofensivo",
          defensive: "Defensivo",
        },
      },
    },
  },
};
